import React, { Fragment } from 'react';
import { string, func, object, bool, array } from 'prop-types';
import { compose, lifecycle } from 'react-recompose';
import styled from 'styled-components';

import { Loader, Dimmer, Segment, Button } from 'semantic-ui-react';
import * as s from '~/state/ducks/app/selectors';
import app from '~/state/ducks/app/actions';
import Modal from '~/views/common/Modal';
import withReduxConnect from '~/views/enhancers/withReduxConnect';
import SearchForm from './SearchForm';
import SearchResults from './SearchResults';
import AffiliateList from '../components/AffiliateList';
import SelectedItems from '../components/SelectedItems';

import { searchPortalsSuperPortal } from '~/state/ducks/organizations/operations';

const TableSection = styled.div`
    position: relative;
    display: flex;
`;

const HelperText = styled.div`
    margin-bottom: 10px;
`;

const AffiliateSelector = ({
    onSubmit,
    initialValues,
    placeholder,
    isLoading,
    isOpen,
    selectedItems,
    setItemSelected,
    setConfirmedItems,
    confirmedAffiliates,
    openModal,
}) => {
    const onDeleteItem = (item, listToCheck) => {
        const newList = [...listToCheck];
        if (listToCheck && item) {
            const itemIndex = listToCheck.findIndex(e => e.id === item.id);
            if (itemIndex !== -1) newList.splice(itemIndex, 1);
        }
        return newList;
    };
    return (
        <Fragment>
            <Button
                type="button"
                primary
                content="Select"
                onClick={() => {
                    setItemSelected(confirmedAffiliates);
                    openModal(true);
                }}
            />
            <AffiliateList
                items={confirmedAffiliates}
                onHandlerDelete={(item) => {
                    const updatedList = onDeleteItem(item, confirmedAffiliates);
                    setConfirmedItems(updatedList);
                    if (onSubmit) { onSubmit(updatedList); }
                }}
            />
            <Modal
                isOpen={isOpen}
                onClose={() => openModal(false)}
                title="Select Affiliate"
                showSubmitButton
                submitButtonText="OK"
                disableSubmitButton={selectedItems.length === 0}
                handleDone={() => {
                    setConfirmedItems(selectedItems);
                    openModal(false);
                    if (onSubmit) { onSubmit(selectedItems); }
                }}
                extraContent={
                    <SelectedItems
                        title="Selected Affiliates: "
                        items={selectedItems}
                        onDeleteItem={(item) => {
                            const updatedItems = onDeleteItem(item, selectedItems);
                            setItemSelected(updatedItems);
                        }}
                    />
                }
            >
                <Fragment>
                    <HelperText>
                        Search affiliates, choose them over the results and then click on OK button.
                    </HelperText>

                    <SearchForm
                        onSubmit={searchPortalsSuperPortal}
                        initialValues={initialValues}
                        placeholder={placeholder}
                    />
                    { isLoading ? (
                        <Dimmer.Dimmable
                            as={Segment}
                            style={{ minHeight: 80 }}
                        >
                            <Dimmer active={isLoading} inverted>
                                <Loader inverted content="Loading" />
                            </Dimmer>
                        </Dimmer.Dimmable>
                    ) : null }
                    <TableSection>
                        <Dimmer active={isLoading} inverted />
                        <SearchResults />
                    </TableSection>
                </Fragment>
            </Modal>
        </Fragment>
    );
};

AffiliateSelector.propTypes = {
    onSubmit: func,
    initialValues: object,
    placeholder: string,
    isLoading: bool,
    isOpen: bool.isRequired,
    selectedItems: array,
    confirmedAffiliates: array.isRequired,
    setItemSelected: func,
    setConfirmedItems: func,
    openModal: func,
};

export default compose(
    withReduxConnect({
        mapStateToProps: state => ({
            isLoading: s.getLoadingSearch(state),
            selectedItems: s.getSelectedAffiliates(state),
            isOpen: s.isAffiliateSelectorOpen(state),
            confirmedAffiliates: s.getConfirmedAffiliates(state),
        }),
        mapDispatchToProps: {
            setItemSelected: app.affiliateSelector.selectedItems.set,
            setConfirmedItems: app.affiliateSelector.confirmedItems.set,
            openModal: app.affiliateSelector.isOpen.set,
        },
    }),
    lifecycle({
        componentDidMount() {
            this.props.setItemSelected([]);
            this.props.setConfirmedItems([]);
        },
    }),
)(AffiliateSelector);
